/**
 * Tunnel page (page-templates/Tunnel.php)
 * Clicking the intro's CTA fades out the intro and fades in the
 * selected Gravity Forms multi-step form.
 */

class Tunnel {
  private readonly TRANSITION_MS = 350;

  private root: HTMLElement | null = document.querySelector('[data-tunnel]');
  private intro: HTMLElement | null = document.querySelector('[data-tunnel-intro]');
  private form: HTMLElement | null = document.querySelector('[data-tunnel-form]');
  private startBtn: HTMLElement | null = document.querySelector('[data-tunnel-start]');

  static init() {
    const instance = new Tunnel();
    instance.bindEvents();
  }

  private bindEvents(): void {
    if (!this.root || !this.intro || !this.form || !this.startBtn) {
      return;
    }

    this.startBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this.showForm();
    });
  }

  private showForm(): void {
    if (!this.intro || !this.form) return;

    const intro = this.intro;
    const form = this.form;

    intro.classList.add('is-leaving');

    window.setTimeout(() => {
      intro.hidden = true;
      intro.classList.remove('is-leaving');

      form.hidden = false;

      // Force a reflow so the enter transition actually runs.
      void form.offsetWidth;

      requestAnimationFrame(() => {
        form.classList.add('is-visible');
      });
    }, this.TRANSITION_MS);
  }
}

export default Tunnel;
